<div class="modal-header" style="display:flex; flex-direction: column;" appCustomAutofocus>
    <h3 style="word-break: break-all;">Advanced Settings - {{item.ItemPrompt}}</h3>
    <div class="row">
        <span *ngIf="lastSave.status && lastSave.time != null" class="badge  badge-success" [ngClass]="{fade: formData.labelFade}" style="margin-left:25px;margin-top:15px;display:table;height: 15px;">Save Successful - {{lastSave.time}}</span>
        <span *ngIf="!lastSave.status && lastSave.time != null" class="badge  badge-danger" [ngClass]="{fade: formData.labelFade}" style="margin-left:25px;margin-top:15px;display:table;height: 15px;">Save Fail - {{lastSave.time}}</span>
    </div>
</div>
<div class="modal-body">
    <div class="row advance-setting-row"
         *ngIf="(item.ResponseTypeID == 7 || item.ResponseTypeID == 15 || item.ResponseTypeID == 8 || item.ResponseTypeID == 9) && (item.IsActive && itemGroup.showTH)">
        <label class="col-5">
            <strong>Lookup</strong>
        </label>
        <div class="col-6 no-padding">
            <div>
                <div class="input-group">
                    <ng-select style="min-width: 200px;"
                               [(ngModel)]="item.ChecklistLookupID"
                               [clearable]=false
                               [searchable]="false"
                               [virtualScroll]="true"
                               (ngModelChange)="updateItem(item, itemGroup.ChecklistTemplateItemGrpID)">
                        <ng-option *ngFor="let data of dropdownTypeList" [value]="data.id">{{data.GroupName}}</ng-option>
                    </ng-select>
                </div>
            </div>
        </div>
    </div>

    <div class="row advance-setting-row" *ngIf="item.ResponseTypeID == 26 && mode !== 'P'">
        <label class="col-5">
            <strong>Personal Info Field</strong>
        </label>
        <div class="col-6 no-padding">
            <ng-select [(ngModel)]="item.PersonalInfoField"
                       [clearable]=false
                       [searchable]="false"
                       [virtualScroll]="true"
                       (ngModelChange)="updateItem(item, itemGroup.ChecklistTemplateItemGrpID)">
                <ng-option *ngFor="let data of personalInfoList" [value]="data.value">{{data.display}}</ng-option>
            </ng-select>
        </div>
    </div>

    <div class="row advance-setting-row"
         *ngIf="(item.ResponseTypeID == 7 || item.ResponseTypeID == 15 || item.ResponseTypeID == 3 || item.ResponseTypeID == 12) &&(item.IsActive && itemGroup.showTH)">
        <label class="col-5">
            <strong>Auto-rebind</strong>
        </label>
        <input type="checkbox"
               [(ngModel)]="item.RebindDropdown"
               style="width:25px;height:25px;"
               (ngModelChange)="updateItem(item, itemGroup.ChecklistTemplateItemGrpID)" />
    </div>

    <div class="row advance-setting-row"
         *ngIf="item.IsActive && (item.ResponseTypeID == 3 || item.ResponseTypeID == 12)">
        <label class="col-5">
            <strong>Max Length</strong>
        </label>
        <div class="validation-field">
            <input type="number"
                   class="form-control"
                   [(ngModel)]="item.MaxResponseLength"
                   (blur)="updateItem(item, itemGroup.ChecklistTemplateItemGrpID)" />
        </div>
    </div>

    <div class="row advance-setting-row"
         *ngIf="item.IsActive && (item.ResponseTypeID == 3 || item.ResponseTypeID == 12)">
        <label class="col-5">
            <strong>Validation Regex</strong>
        </label>
        <div class="validation-field">
            <input type="text"
                   class="form-control"
                   [(ngModel)]="item.ValidationRegex"
                   (blur)="updateItem(item, itemGroup.ChecklistTemplateItemGrpID)" />
        </div>
    </div>

    <div class="row advance-setting-row"
         *ngIf="item.IsActive && item.ResponseTypeID != 3 && item.ResponseTypeID != 10 && item.ResponseTypeID != 21 && (mode === 'P' || item.ResponseTypeID != 26)">
        <label class="col-5"><strong>Show Comments?</strong></label>
        <input type="checkbox"
               [(ngModel)]="item.ShowComments"
               style="width:25px;height:25px;"
               (ngModelChange)="updateItem(item, itemGroup.ChecklistTemplateItemGrpID)" />
    </div>

    <div class="row advance-setting-row" *ngIf="item.IsActive">
        <label class="col-5">
            <strong>Allow User Attachments on Item?</strong>
        </label>
        <input type="checkbox"
               [(ngModel)]="item.ShowAttachments"
               style="width:25px;height:25px;"
               (ngModelChange)="updateItem(item, itemGroup.ChecklistTemplateItemGrpID)" />
    </div>

    <div class="row  advance-setting-row" *ngIf="item.IsActive && item.ShowAttachments">
        <label class="col-5"><strong>Require Attachment?</strong></label>
        <input type="checkbox"
               [(ngModel)]="item.IsRequiredAttachment"
               style="width:25px; height:25px;"
               (ngModelChange)="updateItem(item, itemGroup.ChecklistTemplateItemGrpID)" />
    </div>

    <div class="row  advance-setting-row" *ngIf="item.IsActive && item.ResponseTypeID != 6 && item.ResponseTypeID != 10">
        <label class="col-5"><strong>Response is Required</strong></label>
        <input type="checkbox"
               [(ngModel)]="item.IsRequired"
               style="width:25px;height:25px;"
               (ngModelChange)="updateItem(item, itemGroup.ChecklistTemplateItemGrpID)" />
    </div>

    <div class="row advance-setting-row" *ngIf="item.IsActive && mode === 'O'">
        <label class="col-5"><strong>Admin Only</strong></label>
        <input type="checkbox"
               [(ngModel)]="item.IsAdminField"
               style="width:25px;height:25px;"
               (ngModelChange)="updateItem(item, itemGroup.ChecklistTemplateItemGrpID)" />
    </div>

    <div class="row  advance-setting-row">
        <label class="col-5"><strong>Active</strong></label>
        <input type="checkbox"
               [(ngModel)]="item.IsActive"
               (ngModelChange)="toggleActive()"
               style="width:25px;height:25px;" />
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark"
            (click)="closeClicked()">
        Close
    </button>
</div>
